module.exports = __webpack_public_path__ + "static/media/pl-logo.aa80a24d.svg";